import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosMisviaticosListaComponent {
  busqueda
  catalogos = {
    gasto_categoria: [],
    moneda: [],
  }
  seleccionado = null
  resultados = undefined
  estados = [
    {id: 0, descripcion: 'Todos'},
    {id: 1, descripcion: 'Completados'},
    {id: 2, descripcion: 'Comprobantes Pendientes'},
    {id: 3, descripcion: 'Saldo a Favor'},
    {id: 4, descripcion: 'Sin información'},
  ]
  filtro = {
    estado: 0,
    general: undefined,
  }
  onChange

  constructor ($filter, $q, ViaticosUsuarioViaticosService, ViaticosCatalgosCategoriasviaticoService, ViaticosCatalogosMonedasService) {
    this.$q = $q
    this.filterBy = $filter('filter')
    this.ViaticosUsuarioViaticosService = ViaticosUsuarioViaticosService
    this.ViaticosCatalgosCategoriasviaticoService = ViaticosCatalgosCategoriasviaticoService
    this.ViaticosCatalogosMonedasService = ViaticosCatalogosMonedasService
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ViaticosUsuarioViaticosService.get(this.busqueda.fechaInicial, this.busqueda.fechaFinal)
        .then(({data}) => {
          this.data = data
          this.filtrar()
        }),
      this.ViaticosCatalgosCategoriasviaticoService.get()
        .then(({data}) => (this.catalogos.gasto_categoria = data)),
      this.ViaticosCatalogosMonedasService.get()
        .then(({data}) => (this.catalogos.moneda = data)),
    ])
  }

  eliminar (indice, data) {
    if (!data.eliminado) return
    this.data.splice(indice, 1)
    this.filtrar()
  }

  filtrar () {
    if (this.filtro.general) {
      this.resultados = this.filterBy(this.data, this.filtro.general)
    } else {
      this.resultados = [...this.data]
    }

    if (this.filtro.estado && this.filtro.estado !== 0) {
      switch (this.filtro.estado) {
        case 1 :
          this.resultados = this.resultados.filter((item) => item.suma_anticipos !== 0 && item.suma_detalles !== 0 && item.diferencia === 0)
          break

        case 2 :
          this.resultados = this.resultados.filter((item) => item.diferencia < 0)
          break

        case 3 :
          this.resultados = this.resultados.filter((item) => item.diferencia > 0)
          break

        case 4 :
          this.resultados = this.resultados.filter((item) => item.suma_anticipos === 0 && item.suma_detalles === 0)
          break
      }
    }

    this.resultadosOcultos = this.data.length - this.resultados.length
    this.misviaticos = this.resultados.filter((item) => item.informacion.personal) // Fixme
    this.capturadospormi = this.resultados.filter((item) => !item.informacion.personal) // Fixme
  }
}

module.component('viaticosMisviaticosLista', {
  controller: ViaticosMisviaticosListaComponent,
  template,
  bindings: {
    busqueda: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/misviaticos/lista/component.js